import React from 'react';
import { Select, Form, Input } from '@fpxfd/next';
import { useSetState } from 'ahooks';
import styles from './index.module.scss';
import { SelectProps } from '@fpxfd/next/types/select';
import { TextAreaProps } from '@fpxfd/next/types/input';
import { ItemProps } from '@fpxfd/next/types/form';

const FormItem = Form.Item;
interface InputProps extends TextAreaProps {
  formProps?: ItemProps;
}
interface SearchInputProps {
  selectProps: SelectProps;
  inputProps?: InputProps;
  label?: string;
  callback?: (object) => void;
}

const SearchSelect = ({ selectProps, inputProps, callback, label }: SearchInputProps) => {
  const [selectval, setselectval] = useSetState({
    selects: selectProps.defaultValue || '',
    inputval: '',
    inputName: selectProps.defaultValue || '',
  });
  const getvals = (val, type) => {
    const data = { ...selectval };
    if (type === 'selects') {
      data.selects = val;
      data.inputName = val;
    } else {
      data.inputval = val;
    }
    setselectval(data);
    callback && callback(data);
  };
  return (
    <FormItem label={label}>
      <div className={styles.alltopshow} style={{ marginTop: label ? 0 : 10 }}>
        <FormItem>
          <Select {...selectProps} onChange={(e) => getvals(e, 'selects')} />
        </FormItem>
        <FormItem style={{ width: '100%' }} {...inputProps?.formProps}>
          <Input.TextArea
            size="medium"
            className={styles.textarea}
            {...inputProps}
            name={inputProps?.name || selectval.inputName}
            onChange={(e) => {
              getvals(e, 2);
            }}
          />
        </FormItem>
      </div>
    </FormItem>
  );
};

export default SearchSelect;
